import { useTranslation } from 'react-i18next';
import './style.scss';

import { ReactComponent as OpenNewWindowIcon } from '@assets/images/Open_New_Window_Icon.svg';
import { ButtonCTA } from '@src/global/components/UI Elements/ButtonCTA';

interface SubscriptionButtonProps {
  onClick: () => void;
}

export const SubscriptionButton = ({ onClick }: SubscriptionButtonProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ButtonCTA variant="primary" onClick={() => onClick()}>
        <span>
          {t('subDetails.sub.subscriptionCta')} <OpenNewWindowIcon />
        </span>
      </ButtonCTA>
    </>
  );
};
